import { gql } from 'src/__generated__'

export default gql(`
  mutation addFood($data: CreateFoodInput!) {
    createFood(data: $data) {
      id
    }
  }
`)
